import React from 'react';
import { Alert, Slide, Box } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';
import { useNetworkStatus } from '../../hooks/useNetworkStatus';

const OfflineIndicator: React.FC = () => {
  const { isOnline, wasOffline } = useNetworkStatus();

  // Show reconnected message briefly
  if (wasOffline && isOnline) {
    return (
      <Slide direction="down" in={true} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
          }}
        >
          <Alert
            severity="success"
            icon={<WifiIcon />}
            sx={{
              borderRadius: 0,
              justifyContent: 'center',
            }}
          >
            Back online
          </Alert>
        </Box>
      </Slide>
    );
  }

  // Show offline indicator
  if (!isOnline) {
    return (
      <Slide direction="down" in={true} mountOnEnter unmountOnExit>
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            zIndex: 9999,
          }}
        >
          <Alert
            severity="warning"
            icon={<WifiOffIcon />}
            sx={{
              borderRadius: 0,
              justifyContent: 'center',
            }}
          >
            You are offline. Some features may not be available.
          </Alert>
        </Box>
      </Slide>
    );
  }

  return null;
};

export default OfflineIndicator;
